const n = "loadingIoSpinner_xMVbT", o = "loadingIo_-l52Y", e = "text_fiMmU", l = "fullScreen_SDNev", t = {
  loadingIoSpinner: n,
  loadingIo: o,
  text: e,
  fullScreen: l
};
export {
  t as default,
  l as fullScreen,
  o as loadingIo,
  n as loadingIoSpinner,
  e as text
};
//# sourceMappingURL=loading.module.scss.js.map
